import { motion } from 'framer-motion';
import { useState } from 'react';
import { Filter } from 'lucide-react';

const WorkPage = () => {
  const [activeTab, setActiveTab] = useState('genai');
  const [activeFilter, setActiveFilter] = useState('all');

  const genAIProjects = [
    {
      title: 'Aesthetic Royal Jewellery',
      client: 'CS Jewels',
      category: 'Jewellery Shoot',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2F3%20dim.webp?alt=media&token=01c57d78-d1cd-47f7-a6c4-7aab80fd6561',
      tags: ['product'],
      link: 'https://drive.google.com/drive/folders/1Q_eYyzc5e32iQhTp1Ul7exeBDDVHJY0n?usp=sharing',
    },
    {
      title: 'Udaipur Model Shoot',
      client: 'CS Jewels',
      category: 'Model Shoot',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2F17.jpg?alt=media&token=648f8962-aa0d-442c-8b03-f6b3289f26af',
      tags: ['product'],
      link: 'https://drive.google.com/drive/folders/1w1-BConojokRQTiEJUiEDGhsN6z8UD53?usp=sharing',
    },
    {
      title: 'UN40 Fest',
      client: 'Saregama',
      category: 'AI TVC',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2Fpromotional.png?alt=media&token=6384eb4b-6224-4ba3-a3d8-5c4ce4ea8071',
      tags: ['video', 'cinematic'],
      link: 'https://www.instagram.com/reel/DVlq1a6is3o/',
    },
    {
      title: 'Jewellery Promotional',
      client: 'Avdhoot Jewellers',
      category: 'AI TVC',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2Freplicate_this_exact_202604121121.png?alt=media&token=97131a46-55f8-44b2-bf40-94ecd21af9de',
      tags: ['fashion', 'cinematic'],
      link: 'https://www.youtube.com/shorts/B2tc0aKYMZQ',
    },
    {
      title: 'MCJ Election Video Campaign',
      client: 'BJP Jalgaon',
      category: 'Awareness Campaign',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2FRaju%20Mama.png?alt=media&token=ccb57b1d-2d15-426c-8e00-b1c5c3b61f8f',
      tags: ['election', 'awareness', 'character'],
      link: 'https://www.instagram.com/reel/DSuJ8vWCPPI/?igsh=MW82dmJ5M3ZmNGs4eA%3D%3D',
    },
    {
      title: 'Mangal Graha AI Series',
      client: 'Mangal Graha Mandir Sansthan',
      category: 'AI Series',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2FIndra.webp?alt=media&token=645dd2e3-3ae0-4794-9806-a3cc4af30110',
      tags: ['video', 'cinematic'],
      link: 'https://www.youtube.com/watch?v=IoDMJq8wu38',
    },
    {
      title: 'Educational Awareness',
      client: 'Fusion Scope',
      category: 'Education',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2Feducation.webp?alt=media&token=c06ba314-686a-48d0-a785-46180f886d96',
      tags: ['education'],
      link: 'https://www.youtube.com/watch?v=9DDBUtmeESs',
    },
    {
      title: 'Mati Suposhan Campaign',
      client: 'Mangal Graha Mandir',
      category: 'Awareness',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2Fmati_suposhan.png?alt=media&token=99117346-192b-4512-924f-7053e3acafc9',
      tags: ['awareness'],
      link: 'https://www.instagram.com/reel/DUvJhkVjIpi/?igsh=Mng5OTJkZnF2ODR6',
    },
    {
      title: 'Gulzar Sahab Character Clone',
      client: 'Fusion Scope',
      category: 'Sample',
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2Fgulzar.webp?alt=media&token=fc7c8779-fa37-44f4-ba92-41b7cf69ed89',
      tags: ['character', 'cinematic'],
      link: 'https://www.youtube.com/watch?v=PQdLcZZtwyA',
    },
  ];

  const developmentProjects = [
    {
      title: 'Hello Krushi App',
      category: 'Agricultural App',
      tech: ['Kotlin', 'Java', 'Firestore'],
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2FHF.jpg?alt=media&token=85ddc661-5191-46f4-9f2f-2df0d2690659',
    },
    {
      title: 'Jain Farm Fresh Foods Website',
      category: 'Business Website',
      tech: ['React JS', 'Next JS'],
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2FJFFF.jpg?alt=media&token=c4020774-045c-40e0-941a-0b61293299e6',
    },
    {
      title: 'Indian Red Cross Society, Jalgaon',
      category: 'NGO Website',
      tech: ['PHP', 'Wordpress', 'SQL'],
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2FIRCS.jpg?alt=media&token=9e9d7e73-f8a8-490e-9212-404d0d861e38',
    },
    {
      title: 'Indosource Technologies',
      category: 'Engineering & IoT',
      tech: ['React JS', 'Node JS', 'Firestore'],
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2FIndosource%20Technologies.jpg?alt=media&token=6d2fdc9b-74e5-4ebe-82ab-58dd10af8c7c',
    },
    {
      title: 'My AI Reporter',
      category: 'News Writing AI Tool',
      tech: ['React JS', 'Node JS', 'Mongo DB'],
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2FMYAIR.jpg?alt=media&token=caac602d-52bd-4762-8a14-6bdecd3f44b6',
    },
    {
      title: 'Mangal Graha AI Chatbot',
      category: 'AI Chatbot',
      tech: ['React JS', 'Node JS', 'Mongo DB'],
      image: 'https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Appdroid%20Website%20Data%2FMGM%20logo.jpg?alt=media&token=dc6eec33-15cd-46c5-af31-6603403e9cf1',
    },
  ];

  const filters = [
    { label: 'All', value: 'all' },
    { label: 'Product', value: 'product' },
    { label: 'Fashion', value: 'fashion' },
    { label: 'Character', value: 'character' },
    { label: 'Video', value: 'video' },
    { label: 'Cinematic', value: 'cinematic' },
  ];

  const filteredProjects =
    activeFilter === 'all'
      ? genAIProjects
      : genAIProjects.filter((project) => project.tags.includes(activeFilter));

  return (
    <div data-testid="work-page" className="min-h-screen">
      {/* Hero with Video Background */}
      <section className="min-h-screen flex items-center justify-center relative overflow-hidden">
        {/* Video Background */}
        <div className="absolute inset-0 w-full h-full">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
            style={{ filter: 'brightness(0.6)' }}
          >
            <source
              src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4"
              type="video/mp4"
            />
          </video>
          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
          <div
            className="absolute inset-0 opacity-30"
            style={{
              background:
                'radial-gradient(circle at 50% 50%, rgba(124, 58, 237, 0.2) 0%, rgba(10, 10, 10, 0) 70%)',
            }}
          />
        </div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-6xl md:text-8xl font-black tracking-tighter leading-none uppercase mb-6 text-white drop-shadow-2xl">
              Our Work
            </h1>
            <p className="text-xl md:text-2xl text-white/80 max-w-2xl drop-shadow-lg">Projects that push boundaries.</p>
          </motion.div>
        </div>
      </section>

      {/* Tab Toggle */}
      <section className="pb-12">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex gap-4 border-b border-themed">
            <button
              data-testid="genai-tab"
              onClick={() => {
                setActiveTab('genai');
                setActiveFilter('all');
              }}
              className={`px-8 py-4 text-lg font-bold transition-all relative ${
                activeTab === 'genai'
                  ? 'text-purple-500'
                  : 'text-muted hover:text-white'
              }`}
            >
              Gen AI Work
              {activeTab === 'genai' && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute bottom-0 left-0 right-0 h-0.5 bg-purple-500"
                />
              )}
            </button>
            <button
              data-testid="development-tab"
              onClick={() => {
                setActiveTab('development');
                setActiveFilter('all');
              }}
              className={`px-8 py-4 text-lg font-bold transition-all relative ${
                activeTab === 'development'
                  ? 'text-purple-500'
                  : 'text-muted hover:text-white'
              }`}
            >
              Development Work
              {activeTab === 'development' && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute bottom-0 left-0 right-0 h-0.5 bg-purple-500"
                />
              )}
            </button>
          </div>
        </div>
      </section>

      {/* Filters (for Gen AI tab only) */}
      {activeTab === 'genai' && (
        <section className="pb-12">
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className="flex items-center gap-3 flex-wrap">
              <Filter size={20} className="text-muted" />
              {filters.map((filter) => (
                <button
                  key={filter.value}
                  data-testid={`filter-${filter.value}`}
                  onClick={() => setActiveFilter(filter.value)}
                  className={`px-6 py-2 rounded-full text-sm font-bold transition-all ${
                    activeFilter === filter.value
                      ? 'bg-purple-600 text-white'
                      : 'bg-card text-muted hover:bg-white/10'
                  }`}
                >
                  {filter.label}
                </button>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Projects Grid */}
      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {activeTab === 'genai' ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredProjects.map((project, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{ scale: 1.02 }}
                  className="group cursor-pointer"
                  onClick={() => project.link && window.open(project.link, '_blank')}
                >
                  <div className="relative overflow-hidden rounded-2xl mb-4 aspect-square">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-end p-6">
                      <span className="text-purple-400 text-sm font-bold mb-2">{project.category}</span>
                      <h3 className="text-xl font-bold text-white">{project.title}</h3>
                    </div>
                  </div>
                  <div className="space-y-1">
                    <h3 className="text-lg font-bold">{project.title}</h3>
                    <p className="text-sm text-purple-500">{project.category}</p>
                    <p className="text-sm text-muted">{project.client}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {developmentProjects.map((project, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{ scale: 1.02 }}
                  className="bg-card border border-themed rounded-2xl overflow-hidden hover:border-purple-500/50 transition-all duration-500 group"
                >
                  <div className="aspect-video relative overflow-hidden bg-gradient-to-br from-purple-500/20 to-blue-500/20">
                  {project.image ? (
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    ) : (
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="text-6xl font-black text-white/10">{index + 1}</div>
                      </div>
                    )}
                  </div>

                  <div className="p-6">
                    <h3 className="text-xl font-bold mb-2">{project.title}</h3>
                    <p className="text-sm text-purple-500 mb-3">{project.category}</p>
                    <div className="flex flex-wrap gap-2">
                      {project.tech.map((tech, i) => (
                        <span
                          key={i}
                          className="text-xs bg-card px-3 py-1 rounded-full text-muted"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default WorkPage;